__turbopack_context__.v({
  "adaptive": "card-module-scss-module__hwP8gG__adaptive",
  "bottomController": "card-module-scss-module__hwP8gG__bottomController",
  "bottomPanel": "card-module-scss-module__hwP8gG__bottomPanel",
  "common": "card-module-scss-module__hwP8gG__common",
  "disabled": "card-module-scss-module__hwP8gG__disabled",
  "linkWrap": "card-module-scss-module__hwP8gG__linkWrap",
  "nameLink": "card-module-scss-module__hwP8gG__nameLink",
  "productName": "card-module-scss-module__hwP8gG__productName",
  "rating": "card-module-scss-module__hwP8gG__rating",
  "regular": "card-module-scss-module__hwP8gG__regular",
  "slider": "card-module-scss-module__hwP8gG__slider",
  "topPanel": "card-module-scss-module__hwP8gG__topPanel",
  "wide": "card-module-scss-module__hwP8gG__wide",
  "wideOnMobile": "card-module-scss-module__hwP8gG__wideOnMobile",
});
